/* eslint-disable  */
import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { MOTORSHOW_MODULE } from '@projectJs/contants';
import CommonList from '../commonList';
import RecommendList from '../recommendList'
import LiveList from '../liveList'

import './index.scss'
import { tools } from 'newcar-ui/output/cjs/utils';
import { appMethods } from "newcar-ui/output/es/appMethods";
import { BaseModal } from 'newcar-ui/output/cjs/components/AskpricePublicModal'


const ModuleListPop = (props) => {
    const { type, show, sourceData } = props
    // console.log('moduleListPop', props, type)
    const defaultListCount = 10;
    const isCommonlist = useMemo(() => [1, 2, 3, 4, 5, 6, 7].indexOf(type) > -1, [type])
    const isLive = useMemo(() => type === 10, [type])
    const isRecommedCar = useMemo(() => type === 8, [type])
    const contentRef = useRef(null)
    const [pricePopShow, setPricePopShow] = useState(false)
    const [modelInfo, setModelInfo] = useState({
        productId: '',
        lineId: ''
    })
    const title = useMemo(() => {
        return MOTORSHOW_MODULE[type]
    }, [type])

    useEffect(() => {
        // 防止局部滚动失效
        document.body.style.overflow = 'hidden'
    }, [contentRef, type])

    const handleJump = useCallback((args) => {
        tools.sendClickStatistics_wmda(341, {
            name: title,
            actionType: '24biae-detail-click'
        })
        // console.log(args)
        if (tools.is58App()) {
            appMethods.goto(args?.wbmainUrl)
        } else {
            // window.location.href = args?.
            // 打开新窗口 保持当前页面状态
            window.open(args?.url)
        }
    }, [type])

    const onRecommedCarPrice = useCallback((args) => {
        // console.log('?????', args)
        setPricePopShow(true)
        setModelInfo(args)
    }, [])


    return (
        <div className={`popModule ${show ? 'popModule-moveup' : ''}`}>
            <div className='popModule-close' onClick={props.closeFn}>
                <span></span>
            </div>
            <div className='popModule-title'>{title}</div>
            <div className='popModule-content' ref={contentRef}>
                {
                    isLive && <LiveList data={sourceData} pageCount={defaultListCount} onItemClick={handleJump} contentRef={contentRef}></LiveList>
                }
                {
                    isRecommedCar && <RecommendList data={sourceData} pageCount={defaultListCount} onItemClick={handleJump} onPriceClick={onRecommedCarPrice}></RecommendList>
                }
                {
                    isCommonlist && <CommonList data={sourceData} pageCount={defaultListCount} onItemClick={handleJump}></CommonList>
                }
            </div>
            {/* <div style={{ width: '100%', height: '.4rem;' }}></div> */}
            { /** 三级 pop */}
            {typeof document !== 'undefined' && isRecommedCar &&
                <BaseModal
                    visible={pricePopShow}
                    fCode={1292}
                    // autoScrollId="productsPop_list"
                    closeFun={() => { setPricePopShow(false) }}
                    titleRelate={{
                        mainTitle: '获取底价',
                        btnMainTitle: '立即询价',
                    }}
                    prodInfoRelate={{
                        lineId: modelInfo.lineId,
                        showProdArea: true,
                        showSelectPop: false,
                    }}
                />}
        </div>)
}
export default memo(ModuleListPop);
ModuleListPop.defaultProps = {
    show: false,
    closeFn: () => {

    }
}